import * as React from "react";
import {useState} from "react";

import {
    MathEditorAPIContext,
    MathEditorContext,
} from "@khan/guide-math-editor-context";

export const MathEditorContextProvider = (props: {
    children: React.ReactNode;
}): React.ReactElement => {
    const [openKeypadID, setOpenKeypadID] = useState<string | null>(null);
    const [activeInputs, setActiveInputs] = useState<Record<string, boolean>>(
        {},
    );
    const [sendMessage, setSendMessage] = useState<() => void>(() => () => {});

    const isAnyActive = Object.values(activeInputs).some(
        (isActive) => isActive,
    );

    return (
        <MathEditorAPIContext.Provider
            value={{setOpenKeypadID, setActiveInputs, setSendMessage}}
        >
            <MathEditorContext.Provider
                value={{openKeypadID, isAnyActive, sendMessage}}
            >
                {props.children}
            </MathEditorContext.Provider>
        </MathEditorAPIContext.Provider>
    );
};
